import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import AppLayout from '../components/AppLayout';
import api from '../services/api';
import { toast } from 'react-toastify';
import { routes } from '../lib/routes';

const ALLOWED = ['admin', 'gestor'];

export default function AdminSisobra() {
  const queryClient = useQueryClient();
  const { data: user } = useQuery('me', () => api.get('/usuarios/me').then((r) => r.data), { retry: false });
  const { data: protocolos = [] } = useQuery('protocolos', () => api.get('/protocolos').then((r) => r.data));
  const { data: logs = [] } = useQuery('sisobra-logs', () => api.get('/sisobra/logs').then((r) => r.data));

  const enviarLote = useMutation(
    () =>
      api.post('/sisobra/lotes', {
        assunto: 'alvara',
        protocolo_ids: protocolos.slice(0, 3).map((p) => p.id),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('sisobra-logs');
        toast.success('Lote registrado na fila de integracao.');
      },
      onError: (err) => toast.error(err.response?.data?.error || 'Erro ao gerar lote.'),
    }
  );

  if (user && !ALLOWED.includes(user.tipo)) {
    return <Navigate to={routes.dashboard} replace />;
  }

  return (
    <AppLayout
      title="Integracao Sisobra"
      subtitle="Envio, retificacao e monitoramento."
      actions={
        <Link to={routes.dashboard} className="sispro-btn sispro-btn--secondary sispro-btn--sm">
          Dashboard
        </Link>
      }
    >
      <div className="panel mb-4">
        <div className="flex flex-wrap justify-between items-center gap-3">
          <h2 className="text-lg font-semibold text-[var(--sispro-primary-strong)]">Lotes Sisobra</h2>
          <button type="button" className="sispro-btn sispro-btn--primary" onClick={() => enviarLote.mutate()} disabled={enviarLote.isLoading || !protocolos.length}>
            {enviarLote.isLoading ? 'Processando...' : 'Gerar lote de teste'}
          </button>
        </div>
        {!protocolos.length ? <p className="sispro-empty mt-4">Cadastre protocolos antes de gerar lotes.</p> : null}
      </div>
      <div className="panel overflow-auto">
        <table className="w-full min-w-[700px]">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left">Sistema</th>
              <th className="p-2 text-left">Operacao</th>
              <th className="p-2 text-left">Status</th>
              <th className="p-2 text-left">Data</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id} className="border-t">
                <td className="p-2">{log.sistema}</td>
                <td className="p-2">{log.operacao}</td>
                <td className="p-2">{log.status}</td>
                <td className="p-2">{log.created_at ? new Date(log.created_at).toLocaleString('pt-BR') : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!logs.length ? <p className="sispro-empty py-6">Nenhum log ainda.</p> : null}
      </div>
    </AppLayout>
  );
}
